import { dsl } from '@wix/yoshi-serverless/wrap';

export const categories = dsl({
          functionName: 'categories',
          fileName: 'api/categories/categories.api',
        });